export enum rbacActions {
    ViewDashboard = 'ViewDashboard',
    ViewProfile = 'ViewProfile',


    ListBillingProviders = 'ListBillingProviders',
    GetBillingProvider = 'GetBillingProvider',
    CreateBillingProvider = 'CreateBillingProvider',
    UpdateBillingProvider = 'UpdateBillingProvider',
    DeleteBillingProvider = 'DeleteBillingProvider',

    ListActivityLogs = 'ListActivityLogs',
    GetActivityLog = 'GetActivityLog',
    CreateActivityLog = 'CreateActivityLog',
    UpdateActivityLog = 'UpdateActivityLog',
    DeleteActivityLog = 'DeleteActivityLog',

    ListMeters = 'ListMeters',
    GetMeter = 'GetMeter',
    CreateMeter = 'CreateMeter',
    UpdateMeter = 'UpdateMeter',
    DeleteMeter = 'DeleteMeter',

    ListMeterAssignments = 'ListMeterAssignments',
    GetMeterAssignment = 'GetMeterAssignment',
    CreateMeterAssignment = 'CreateMeterAssignment',
    UpdateMeterAssignment = 'UpdateMeterAssignment',
    DeleteMeterAssignment = 'DeleteMeterAssignment',

    // FNP-533: BillableEvents is a read-only admin surface — only the two read
    // actions exist (no Create/Update/Delete).
    ListBillableEvents = 'ListBillableEvents',
    GetBillableEvent = 'GetBillableEvent',

    // FNP-534: MeteringRecords is a read-only admin surface — only the two read
    // actions exist (no Create/Update/Delete; the aggregator owns the lifecycle).
    ListMeteringRecords = 'ListMeteringRecords',
    GetMeteringRecord = 'GetMeteringRecord',

    ListOrders = 'ListOrders',
    GetOrder = 'GetOrder',
    CreateOrder = 'CreateOrder',
    UpdateOrder = 'UpdateOrder',
    DeleteOrder = 'DeleteOrder',

    ListProducts = 'ListProducts',
    GetProduct = 'GetProduct',
    CreateProduct = 'CreateProduct',
    UpdateProduct = 'UpdateProduct',
    DeleteProduct = 'DeleteProduct',

    ListProductFeatures = 'ListProductFeatures',
    GetProductFeature = 'GetProductFeature',
    CreateProductFeature = 'CreateProductFeature',
    UpdateProductFeature = 'UpdateProductFeature',
    DeleteProductFeature = 'DeleteProductFeature',


    ListRatePlans = 'ListRatePlans',
    GetRatePlan = 'GetRatePlan',
    CreateRatePlan = 'CreateRatePlan',
    UpdateRatePlan = 'UpdateRatePlan',
    DeleteRatePlan = 'DeleteRatePlan',

    ListSubscriptions = 'ListSubscriptions',
    GetSubscription = 'GetSubscription',
    CreateSubscription = 'CreateSubscription',
    UpdateSubscription = 'UpdateSubscription',
    DeleteSubscription = 'DeleteSubscription',

    ListInvoices = 'ListInvoices',
    GetInvoice = 'GetInvoice',
    CreateInvoice = 'CreateInvoice',
    UpdateInvoice = 'UpdateInvoice',
    DeleteInvoice = 'DeleteInvoice',

    ListInvoiceItems = 'ListInvoiceItems',
    GetInvoiceItem = 'GetInvoiceItem',

    ListPrices = 'ListPrices',
    GetPrice = 'GetPrice',
    CreatePrice = 'CreatePrice',
    UpdatePrice = 'UpdatePrice',
    DeletePrice = 'DeletePrice',

    ListCustomers = 'ListCustomers',
    GetCustomer = 'GetCustomer',
    CreateCustomer = 'CreateCustomer',
    UpdateCustomer = 'UpdateCustomer',
    DeleteCustomer = 'DeleteCustomer',

    ListPaymentProfiles = 'ListPaymentProfiles',
    GetPaymentProfile = 'GetPaymentProfile',
    CreatePaymentProfile = 'CreatePaymentProfile',
    UpdatePaymentProfile = 'UpdatePaymentProfile',
    DeletePaymentProfile = 'DeletePaymentProfile',

    ListProductLineItems = 'ListProductLineItems',
    GetProductLineItem = 'GetProductLineItem',
    CreateProductLineItem = 'CreateProductLineItem',
    UpdateProductLineItem = 'UpdateProductLineItem',
    DeleteProductLineItem = 'DeleteProductLineItem',

    ListSubscriptionItems = 'ListSubscriptionItems',
    GetSubscriptionItem = 'GetSubscriptionItem',
    CreateSubscriptionItem = 'CreateSubscriptionItem',
    UpdateSubscriptionItem = 'UpdateSubscriptionItem',
    DeleteSubscriptionItem = 'DeleteSubscriptionItem',

    ListProviderMappings = 'ListProviderMappings',
    GetProviderMapping = 'GetProviderMapping',
    CreateProviderMapping = 'CreateProviderMapping',
    UpdateProviderMapping = 'UpdateProviderMapping',
    DeleteProviderMapping = 'DeleteProviderMapping'

}

export const actions = Object.values(rbacActions);

export const actionConstants = actions.reduce((acc, action) => {
    acc[action.replace(/[A-Z]/g, (match, offset) => (offset > 0 ? '_' : '') + match.toLowerCase())
              .toUpperCase()] = action;
    return acc;
}, {} as Record<string, string>);